import { NgIf } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SvgComponent } from '@app/base-components';
import { AbstractContentfulBase } from '@app/contentful';
import { HabaQaId, newsletterUrl } from '@app/helpers';
import { CustomSiteContext } from '@app/services';
import { Entry } from 'contentful';
import { DataLayerService, DlEventName, NewsletterData } from 'haba-base-components';
import {
  ContentfulDynamicComponentRestService,
  ContentfulRestService,
  ContentfulSeoMetadataService,
  Page,
} from 'haba-contentful-components';
import { PageMeta, WindowRef } from 'haba-core';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-newsletter-subscription-success',
  templateUrl: './newsletter-subscription-success.component.html',
  styleUrls: ['./newsletter-subscription-success.component.scss'],
  imports: [NgIf, SvgComponent],
})
export class NewsletterSubscriptionSuccessComponent
  extends AbstractContentfulBase
  implements OnInit, AfterViewInit
{
  @ViewChild('container', { read: ViewContainerRef }) public target: ViewContainerRef;
  @ViewChild('checkMark') public checkMark: ElementRef;

  public entry: Entry<Page>;
  public checkMarkContainer: HTMLElement;
  public successContainerQaId: HabaQaId;
  private baseQaId: HabaQaId;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected siteContextService: CustomSiteContext,
    protected contentfulRestService: ContentfulRestService,
    protected contentfulDynamicComponentRestService: ContentfulDynamicComponentRestService,
    protected cdr: ChangeDetectorRef,
    protected contentfulSeoMetadataService: ContentfulSeoMetadataService,
    protected winRef: WindowRef,
    private _elementRef: ElementRef,
    private renderer2: Renderer2,
    private dataLayerService: DataLayerService
  ) {
    super(router, siteContextService);
  }

  ngOnInit() {
    this.initIds();
  }

  ngAfterViewInit(): void {
    this.contentfulRestService
      .getPageBySlug(`${newsletterUrl.subscriptionSuccess}`, this.locale)
      .pipe(first())
      .subscribe((entry: Entry<Page> | null) => {
        if (entry === null) {
          this.notFound();
        } else {
          this.entry = entry;
          const pageMeta: PageMeta = {
            title: this.contentfulSeoMetadataService.getTitle(entry),
            description: this.contentfulSeoMetadataService.getDescription(entry),
            image: this.contentfulSeoMetadataService.getImage(entry),
            robots: this.contentfulSeoMetadataService.getRobots(entry),
            canonicalUrl: this.contentfulSeoMetadataService.getCanonicalUrl(entry, this.winRef),
          };
          this.contentfulSeoMetadataService.setMetadata(pageMeta);
          this.contentfulDynamicComponentRestService.renderComponents(
            entry.fields.content,
            this.target
          );
          const xid = this.route.snapshot.queryParamMap.get('xid');
          this.dataLayerService.setDataLayerFromEvent(DlEventName.NEWSLETTER_FORM_SUBMIT, {
            stepNumber: 3,
            xid,
          } as NewsletterData);
          this.implementPageComponents();
          this.cdr.detectChanges();
        }
      });
  }

  private implementPageComponents(): void {
    const [checkMarkContainer] = this._elementRef.nativeElement.querySelectorAll(
      'hcc-internal-logic > div'
    );
    this.checkMarkContainer = checkMarkContainer;

    this.appendIfParentAvailable('checkMark', checkMarkContainer);
  }

  private appendIfParentAvailable(containerTitle: string, parent: HTMLElement): void {
    if (
      parent &&
      this.entry.fields.content.find(
        (container) => container.fields?.internalIdentifier === containerTitle
      )
    ) {
      this.renderer2.appendChild(parent, this[containerTitle].nativeElement);
    }
  }

  private initIds(): void {
    this.baseQaId = HabaQaId.forPage(HabaQaId.page.newsletterSubscriptionSuccess);
    this.successContainerQaId = this.baseQaId.forSection(HabaQaId.section.container);
  }
}
